import { AfterViewInit, Component, ElementRef, input, OnDestroy, ViewChild } from '@angular/core';

import { LexXiTagComponent } from 'app/components/xi-components/lex-xi-tag/lex-xi-tag.component';
import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from 'app/services/otel.service';
import { ConfigurationUtils } from 'app/utils/configuration.utils';
import { SemantriaConfiguration } from '../../../../providers/semantria-api/configuration.service';

@EnableClassTelemetry()
@Component({
  selector: 'app-tag-autowrap',
  templateUrl: './tag-autowrap.component.html',
  styleUrls: ['./tag-autowrap.component.scss'],
  standalone: false,
})
export class TagAutowrapComponent implements AfterViewInit, OnDestroy {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  @ViewChild('tagsContainer', { read: ElementRef, static: true }) tagsContainer: ElementRef;

  @ViewChild('userEtc', { static: true }) userEtc: LexXiTagComponent;

  readonly configuration = input<SemantriaConfiguration>();

  private resizeObserver: ResizeObserver;
  private mutationObserver: MutationObserver;

  ngAfterViewInit() {
    const container = this.tagsContainer.nativeElement;

    this.resizeObserver = new ResizeObserver(() => this.redrawTags());
    this.resizeObserver.observe(container);

    this.mutationObserver = new MutationObserver(() => this.redrawTags());
    this.mutationObserver.observe(container, { childList: true });
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
    this.mutationObserver?.disconnect();
  }

  private redrawTags() {
    const tags = this.tagsContainer.nativeElement.querySelectorAll('app-lex-xi-tag');
    tags.forEach((el) => (el.style.display = ''));

    const spaceNeeded = 70;
    const containerWidth = this.tagsContainer.nativeElement.offsetWidth;

    let idx = tags.length - 2;
    let cnt = 0;
    while (
      idx > -1 &&
      tags[idx].offsetLeft + tags[idx].offsetWidth > containerWidth - spaceNeeded
    ) {
      tags[idx--].style.display = 'none';
      cnt++;
    }

    if (cnt > 0) {
      tags[tags.length - 1].style.display = 'initial';
      this.userEtc.text = `+${cnt}`;
    } else {
      tags[tags.length - 1].style.display = 'none';
    }

    tags.forEach((el) => (el.style.visibility = 'visible'));
  }

  hasEieTag() {
    return ConfigurationUtils.hasEieTag(this.configuration());
  }

  getEieTagText() {
    return ConfigurationUtils.getEieTagText(this.configuration());
  }

  getEieTagTooltipText() {
    return ConfigurationUtils.getEieTagTooltipText(this.configuration());
  }
}
